import script from "./kalio-invite-founders.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-invite-founders.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__